import { render } from "./DividerComponent2.vue?vue&type=template&id=77601f47&scoped=true"
const script = {}

import "./DividerComponent2.vue?vue&type=style&index=0&id=77601f47&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77601f47"]])

export default __exports__